import Video from '@commons/video/Video'
import viewportHelper from '@content/helpers/src/viewport.helpers.ts'
import styles from './Background.module.scss'
import { BackgroundProps } from './types'

const Background = ({
    retina,
    desktop,
    mobile,
    video,
    overlay,
    rounded = false
}: BackgroundProps) => {
    const overlayColorMap = {
        full: styles.backgroundOverlayBlack,
        'gradient-left': styles.backgroundOverlayBlackGradientLeft,
        'gradient-left-corner': styles.backgroundOverlayBlackGradientLeft,
        'gradient-center': styles.backgroundOverlayBlack,
        'gradient-bottom': styles.backgroundOverlayBlackGradientBottom
    }

    const overlayClass = `${overlay ? `${styles.backgroundOverlay} ${overlayColorMap[overlay]}` : ''} `
    const roundedClass = rounded ? styles.rounded : ''

    const getBackgroundType = () => {
        if (viewportHelper.is.desktop) {
            return desktop?.src
        } else if (viewportHelper.is.retina) {
            return retina?.src
        }

        return mobile
    }

    if (video?.url) {
        return (
            <Video
                className={overlayClass}
                auto_play={video.config.auto_play}
                url={video.url}
                urlMobile={video.url_mobile}
                {...video}></Video>
        )
    }

    return (
        <div
            style={{ backgroundImage: `url(${getBackgroundType()})` }}
            className={`${styles.backgroundWrapper} ${roundedClass} ${overlayClass}`}></div>
    )
}

export default Background
